import {
  WiDaySunny,
  WiDayCloudy,
  WiFog,
  WiSprinkle,
  WiRain,
  WiRainMix,
  WiSnow,
  WiHail,
  WiShowers,
  WiSnowWind,
  WiThunderstorm
} from "react-icons/wi";

export const getWeatherIcon = (code, size = 30) => {

  if (code === 0) return <WiDaySunny size={size} />;

  if ([1, 2, 3].includes(code))
    return <WiDayCloudy size={size} />;

  if ([45, 48].includes(code))
    return <WiFog size={size} />;

  if ([51, 53, 55].includes(code))
    return <WiSprinkle size={size} />;

  if ([56, 57].includes(code))
    return <WiRainMix size={size} />;

  if ([61, 63, 65].includes(code))
    return <WiRain size={size} />;

  if ([66, 67].includes(code))
    return <WiRainMix size={size} />;

  if ([71, 73, 75].includes(code))
    return <WiSnow size={size} />;

  if (code === 77)
    return <WiHail size={size} />;

  if ([80, 81, 82].includes(code))
    return <WiShowers size={size} />;

  if ([85, 86].includes(code))
    return <WiSnowWind size={size} />;

  if (code === 95)
    return <WiThunderstorm size={size} />;

  if ([96, 99].includes(code))
    return <WiThunderstorm size={size} />;

  return <WiDaySunny size={size} />;
};